import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation, useParams } from 'react-router';
import * as AuthService from "../Service/AuthService";

let lastKey = '';

export function withReactRouter(Component: any) {
  function WrappedComponent(props: any) {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    React.useEffect(() => {
      if (lastKey === location.key) {
        return;
      }

      const _paq = window._paq;
      if (_paq) {
        if (AuthService.getUser()) {
          const user = AuthService.getUser();
          _paq.push(['setUserId', user.email]);
        }
        _paq.push(['setCustomUrl', location.pathname]);
        _paq.push(['trackPageView']);
        lastKey = location.key;
      }
    }, [location]);

    return <Component
      navigate={navigate}
      params={params}
      location={location}
      {...props}
    />;
  }

  return WrappedComponent;
}
